<template>
  <section class="p-24 bg-neutral-5 flex flex-col">
    <div class="flex justify-between">

      <div class="inline-flex items-center gap-6">
        <q-icon class="opacity-40" size="1.5rem" name="history"></q-icon>
        <span class="text-pararaphy-1 text-neutral-100 font-medium">{{
          t('history')
        }}</span>
      </div>

    </div>
    <OHistorico :logs="toRaw(logAlt)" :loading="logLoading" class="flex-1" />
  </section>
</template>

<script setup>
import { logsService } from 'js/vue/services/logs.service'
import { onMounted, ref, toRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import OHistorico from 'components/Historico/OHistorico.vue'

const { t } = useI18n()

const logLoading = ref(true)

const { getLogsById, getLogs } = logsService()

const { rowId } = defineProps({
  rowId: Number,
})

const logAlt = ref([])

onMounted(async () => {
  const { results } = await getLogs(`?solicitacao_arquivo=${rowId}`)
  logAlt.value = results
  logLoading.value = false
})
</script>

<style lang="scss" scoped></style>
